import { toast } from '@hivebrite/design-system/Toast';

import { displayXhrError } from 'hb-react/frontoffice/utils/globalUtils';
import { axiosWithSyntaxHandlers as axios } from 'hb-react/shared/utils/axios';

export const fetchDonations = (donationsUrl, params = {}) =>
  axios
    .get(donationsUrl, {
      params: {
        ...params,
        fetchDonations: true,
        fetchCategories: false,
      },
    })
    .then(
      ({ data }) => ({
        items: data.donations.campaigns,
        totalItems: data.donations.total,
      }),
      displayXhrError,
    )
    .catch((error) => {
      toast.error(error?.responseText ?? __('Sorry, an error occurred'));
    });

export const fetchCategories = (donationsUrl) =>
  axios
    .get(donationsUrl, {
      params: { fetchDonations: false, fetchCategories: true },
    })
    .then(
      ({ data }) =>
        data.donations.categories.map((c) => ({
          name: `cat_${c.id}`,
          label: c.name,
          query: {
            [`cat_${c.id}`]: c.id,
          },
        })),
      displayXhrError,
    )
    .catch((error) => {
      toast.error(error?.responseText ?? __('Sorry, an error occurred'));
    });
